import { render, staticRenderFns } from "./NotificationSettingTab.vue?vue&type=template&id=81ba91e6&scoped=true&lang=pug"
import script from "./NotificationSettingTab.vue?vue&type=script&lang=ts"
export * from "./NotificationSettingTab.vue?vue&type=script&lang=ts"
import style0 from "./NotificationSettingTab.vue?vue&type=style&index=0&id=81ba91e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ba91e6",
  null
  
)

export default component.exports